// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "datapipelines/v1/datapipelines.proto" (package "datapipelines.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal and private data managment RPCs and protos
//
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { InternalDataPipelinesService } from "./datapipelines";
import type { GetDataPipelineSummaryResponse } from "./datapipelines";
import type { GetDataPipelineSummaryRequest } from "./datapipelines";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { ListDataPipelineSummariesResponse } from "./datapipelines";
import type { ListDataPipelineSummariesRequest } from "./datapipelines";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service datapipelines.v1.InternalDataPipelinesService
 */
export interface IInternalDataPipelinesServiceClient {
    /**
     * @generated from protobuf rpc: ListDataPipelineSummaries(datapipelines.v1.ListDataPipelineSummariesRequest) returns (datapipelines.v1.ListDataPipelineSummariesResponse);
     */
    listDataPipelineSummaries(input: ListDataPipelineSummariesRequest, options?: RpcOptions): UnaryCall<ListDataPipelineSummariesRequest, ListDataPipelineSummariesResponse>;
    /**
     * @generated from protobuf rpc: GetDataPipelineSummary(datapipelines.v1.GetDataPipelineSummaryRequest) returns (datapipelines.v1.GetDataPipelineSummaryResponse);
     */
    getDataPipelineSummary(input: GetDataPipelineSummaryRequest, options?: RpcOptions): UnaryCall<GetDataPipelineSummaryRequest, GetDataPipelineSummaryResponse>;
}
/**
 * @generated from protobuf service datapipelines.v1.InternalDataPipelinesService
 */
export class InternalDataPipelinesServiceClient implements IInternalDataPipelinesServiceClient, ServiceInfo {
    typeName = InternalDataPipelinesService.typeName;
    methods = InternalDataPipelinesService.methods;
    options = InternalDataPipelinesService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: ListDataPipelineSummaries(datapipelines.v1.ListDataPipelineSummariesRequest) returns (datapipelines.v1.ListDataPipelineSummariesResponse);
     */
    listDataPipelineSummaries(input: ListDataPipelineSummariesRequest, options?: RpcOptions): UnaryCall<ListDataPipelineSummariesRequest, ListDataPipelineSummariesResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListDataPipelineSummariesRequest, ListDataPipelineSummariesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetDataPipelineSummary(datapipelines.v1.GetDataPipelineSummaryRequest) returns (datapipelines.v1.GetDataPipelineSummaryResponse);
     */
    getDataPipelineSummary(input: GetDataPipelineSummaryRequest, options?: RpcOptions): UnaryCall<GetDataPipelineSummaryRequest, GetDataPipelineSummaryResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetDataPipelineSummaryRequest, GetDataPipelineSummaryResponse>("unary", this._transport, method, opt, input);
    }
}
